import Cookies from 'js-cookie';
export function useAccessToken(sessionCookieName) {
    var _a;
    var sessionCookie = Cookies.get(sessionCookieName);
    var robinSession = (sessionCookie && JSON.parse(sessionCookie));
    return { accessToken: (_a = robinSession === null || robinSession === void 0 ? void 0 : robinSession.access_token) !== null && _a !== void 0 ? _a : null };
}
